import { accordionClasses } from '@mui/material/Accordion';
import { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    // MUI v4 hid the divider of any recipe that follows an expanded one; MUI 9 only does it between two expanded ones
    accordion: {
        [`.${accordionClasses.expanded} + &::before`]: {
            display: 'none',
        },
    },
    // MUI v4 rendered the expand icon as an IconButton: 12px padding and a -12px end margin
    summary: {
        [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
            p: '12px',
            mr: '-12px',
        },
    },
    // MUI v4 laid out AccordionDetails as a flex row
    details: {
        display: 'flex',
    },
} satisfies Record<string, SxProps<Theme>>;
